import { Skeleton } from './skeleton'

/**
 * Skeleton for the profile section in sidebar/mobile menu
 * Shows avatar, name/email placeholders, and action buttons
 */
export function ProfileSkeleton() {
  return (
    <div className="p-3 border-t border-white/[0.08]">
      {/* User info skeleton */}
      <div className="flex items-center gap-3 px-2 py-2">
        <Skeleton className="size-10 rounded-full" />
        <div className="flex-1 min-w-0">
          <Skeleton className="h-4 w-40" />
        </div>
      </div>

      {/* Actions skeleton */}
      <div className="mt-3 pt-3 border-t border-white/[0.06] space-y-0.5">
        <div className="flex items-center gap-3 px-3 py-2">
          <Skeleton className="size-4 rounded" />
          <Skeleton className="h-4 w-28" />
        </div>
        <div className="flex items-center gap-3 px-3 py-2">
          <Skeleton className="size-4 rounded" />
          <Skeleton className="h-4 w-16" />
        </div>
      </div>
    </div>
  )
}

/**
 * Skeleton for mobile profile section (slightly different sizing)
 */
export function MobileProfileSkeleton() {
  return (
    <div className="space-y-1">
      <div className="pb-2 text-xs font-medium text-[#555] uppercase tracking-wider">
        Account
      </div>
      {/* User info skeleton */}
      <div className="flex items-center gap-3 px-4 py-3">
        <Skeleton className="size-8 rounded-full" />
        <Skeleton className="h-4 w-40" />
      </div>
      {/* Action buttons skeleton */}
      <div className="flex items-center gap-3 px-4 py-3">
        <Skeleton className="size-5 rounded" />
        <Skeleton className="h-4 w-28" />
      </div>
      <div className="flex items-center gap-3 px-4 py-3">
        <Skeleton className="size-5 rounded" />
        <Skeleton className="h-4 w-16" />
      </div>
    </div>
  )
}

/**
 * Skeleton for nav items that depend on user plan state
 * Used for the billing/upgrade button in sidebar
 */
export function NavItemSkeleton() {
  return (
    <div className="flex items-center gap-3 w-full px-4 py-3 rounded-lg text-sm">
      <Skeleton className="size-[18px] rounded" />
      <Skeleton className="h-5 w-16" />
    </div>
  )
}

/**
 * Skeleton for mobile nav items
 */
export function MobileNavItemSkeleton() {
  return (
    <div className="flex items-center gap-3 px-4 py-3 rounded-xl">
      <Skeleton className="size-5 rounded" />
      <Skeleton className="h-4 w-16" />
    </div>
  )
}

/**
 * Skeleton for the credits counter in top bar
 */
export function CreditsCounterSkeleton() {
  return (
    <div className="flex items-center gap-2 px-3 py-1.5 rounded-md glass text-sm">
      <Skeleton className="size-4 rounded" />
      <Skeleton className="h-5 w-12" />
    </div>
  )
}

/**
 * Skeleton for top bar actions (credits + new video button) while Clerk loads
 */
export function TopBarActionsSkeleton() {
  return (
    <div className="flex items-center gap-3">
      <CreditsCounterSkeleton />
      <div className="rounded-lg glass-active px-2.5 py-1.5 md:px-3">
        <div className="flex items-center gap-1.5">
          <Skeleton className="size-3.5 rounded" />
          <Skeleton className="hidden md:block h-4 w-16" />
        </div>
      </div>
    </div>
  )
}
